import React from "react";

function formatDate(dateStr: string) {
	if (!dateStr) return "";
	const [year, month, day] = dateStr.split("-");
	if (!year || !month || !day) return dateStr;
	return `${day}/${month}/${year}`;
}

function formatDateLongEs(dateStr: string) {
	if (!dateStr) return "";

	const [yearStr, monthStr, dayStr] = dateStr.split("-");
	const year = Number(yearStr);
	const month = Number(monthStr);
	const day = Number(dayStr);

	if (!year || !month || !day) return dateStr;

	const months = [
		"enero",
		"febrero",
		"marzo",
		"abril",
		"mayo",
		"junio",
		"julio",
		"agosto",
		"septiembre",
		"octubre",
		"noviembre",
		"diciembre",
	];

	const monthName = months[month - 1];
	if (!monthName) return dateStr;

	return `${day} de ${monthName} de ${year}`;
}

interface CardOfferProps {
	image?: string;
	title?: string;
	desc?: string;
	fromTitle?: string;
	fromDate?: string;
	toTitle?: string;
	toDate?: string;
	linkLabel?: string;
	linkHref?: string;
	offerCupon?: string;
	buttonLabel?: string;
	buttonLink?: string;
	className?: string;
	index?: number;
	termsAndConditions?: string;
	cardRedirection?: string;
	[key: string]: any;
}

const CardOffer = ({
	image,
	title,
	desc,
	fromTitle,
	fromDate,
	toTitle,
	toDate,
	linkLabel,
	linkHref,
	offerCupon,
	buttonLabel,
	buttonLink,
	className = "",
	index,
	cardRedirection,
	termsAndConditions = "Ad consectetur veniam ut eu laborum occaecat ipsum velit sit elit reprehenderit proident.",
	...props
}: CardOfferProps) => {
	const isLinkWrapper = cardRedirection === "enable";
	const Wrapper: React.ElementType = isLinkWrapper ? "a" : "div";
	const wrapperSpecificProps = isLinkWrapper
		? {
				href: linkHref || buttonLink || "#",
				target: "_blank",
				rel: "noopener",
		  }
		: {};

	const dateRangeLabel =
		fromDate && toDate
			? `Desde el ${formatDateLongEs(fromDate)}, hasta el ${formatDateLongEs(toDate)}`
			: fromDate
				? `Desde el ${formatDateLongEs(fromDate)}`
				: toDate
					? `Hasta el ${formatDateLongEs(toDate)}`
					: "";

	return (
		<>
			<Wrapper
				className={`card__offer ${className}`}
				// {...wrapperSpecificProps}
				{...props}
			>
				<div className="card__offer__header-img">
					{image && (
						<img
							src={
								image?.includes("http")
									? image
									: `${window.location.origin}${image}`
							}
							className="card__offer__header-img__image"
							alt={`Imagen de la oferta - ${title}`}
						/>
					)}
				</div>
				<div className="card__offer__body">
					<div className="card__offer__body__title">{title}</div>
					<div
						dangerouslySetInnerHTML={{ __html: desc }}
						className="card__offer__body__desc"
					/>
					<div className="card__offer__actions">
						<div
							className="card__offer__link card__offer__action sc-button sc-button-secondary sc-button-small"
							data-index={`sc-card-offer__pop-up${index}`}
						>
							<span>Ver mas detalles</span>
						</div>
						{buttonLink && (
							<a
								href={buttonLink}
								className="card__offer__action sc-button sc-button-tertiary-green sc-button-small"
								target="_blank"
								rel="noopener"
							>
								Ir a la tienda
							</a>
						)}
					</div>
				</div>
			</Wrapper>

			<div
				id={`sc-card-offer__pop-up${index}`}
				className="sc-card-offer__pop-up "
				style={{ display: "none" }}
			>
				<div className="sc-card-offer__pop-up__overlay"></div>
				<div className="sc-card-offer__pop-up__content">
					<div className="sc-card-offer__pop-up__content__close">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
						>
							<path d="M18.4375 17.1484C18.7891 17.5391 18.7891 18.125 18.4375 18.4766C18.0469 18.8672 17.4609 18.8672 17.1094 18.4766L12.5 13.8281L7.85156 18.4766C7.46094 18.8672 6.875 18.8672 6.52344 18.4766C6.13281 18.125 6.13281 17.5391 6.52344 17.1484L11.1719 12.5L6.52344 7.85156C6.13281 7.46094 6.13281 6.875 6.52344 6.52344C6.875 6.13281 7.46094 6.13281 7.8125 6.52344L12.5 11.2109L17.1484 6.5625C17.5 6.17188 18.0859 6.17188 18.4375 6.5625C18.8281 6.91406 18.8281 7.5 18.4375 7.89062L13.7891 12.5L18.4375 17.1484Z" />
						</svg>
					</div>
					{image && (
						<img
							className="sc-card-offer__pop-up__content__image"
							src={
								image?.includes("http")
									? image
									: `${window.location.origin}${image}`
							}
							alt={`Imagen de la oferta - ${title}`}
						></img>
					)}
					<div className="sc-card-offer__pop-up__content__header">
						<h4>{title}</h4>
						<h2>
							<div dangerouslySetInnerHTML={{ __html: desc }}></div>
						</h2>
					</div>
					{offerCupon && (
						<div className="sc-card-offer__pop-up__content__cupon">
							<img
								className="sc-card-offer__pop-up__content__cupon__icon"
								src={`${window.location.origin}/wp-content/themes/sistecredito/assets/img/offers/cupon.png`}
								alt="Icono cupón"
							/>
							<strong className="sc-card-offer__pop-up__content__cupon__label">
								Usa este cupón:
							</strong>
							<span className="sc-card-offer__pop-up__content__cupon__value">
								{offerCupon}
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="32"
									height="32"
									viewBox="0 0 24 24"
									fill="none"
									style={{ padding: "8px 9px", boxSizing: "border-box", borderRadius: "999px", flexShrink: 0 }}
								>
									<path
										d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
										fill="currentColor"
									/>
								</svg>
							</span>
						</div>
					)}
					{dateRangeLabel && (
						<div className="sc-card-offer__pop-up__content__date-line">
							<img
								className="sc-card-offer__pop-up__content__date-line__icon"
								src={`${window.location.origin}/wp-content/themes/sistecredito/assets/img/offers/vigencia.png`}
								alt="sc-offers__offers-container end date"
							/>
							<span className="sc-card-offer__pop-up__content__date-line__text">
								<strong className="sc-card-offer__pop-up__content__date-line__label">
									Vigencia:
								</strong>{" "}
								<span className="sc-card-offer__pop-up__content__date-line__value">
									{dateRangeLabel}
								</span>
							</span>
						</div>
					)}
					{buttonLink && buttonLabel && (
						<a
							href={buttonLink}
							className="sc-button sc-button-primary-green sc-button-small sc-card-offer__pop-up__content__button"
							target="_blank"
							rel="noopener"
						>
							{buttonLabel}
						</a>
					)}
					{termsAndConditions && (
						<details className="sc-card-offer__pop-up__content__terms">
							<summary className="sc-card-offer__pop-up__content__terms__toggle">
								<strong>Ver condiciones</strong>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									width="16"
									height="16"
									viewBox="0 0 16 16"
									fill="none"
									className="sc-card-offer__pop-up__content__terms__chevron"
								>
									<path
										d="M4.5 10L8 6.5L11.5 10"
										stroke="currentColor"
										strokeWidth="1.75"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							</summary>
							<div
								className="sc-card-offer__pop-up__content__terms__content"
								dangerouslySetInnerHTML={{ __html: termsAndConditions }}
							></div>
						</details>
					)}
				</div>
			</div>
		</>
	);
};

export default CardOffer;
